<div class="queries-tree-container" fxLayout="column">
  <opath-core-nav-header class="queries-tree-title" [title]="generalProperties" [hideFilterPanel]="true">
  </opath-core-nav-header>

  <div
    cdkDropList
    id="queriesTree"
    cdkDropListConnectedTo="objectTypes"
    [cdkDropListData]="queries"
    (cdkDropListDropped)="drop($event)"
    class="objectType-selected-container"
    #boundaryContainer
    fxFlex="100"
  >
    <abc-tree
      #queriesTree
      [data]="[queries]"
      [selectByClick]="true"
      [focusStateEnabled]="false"
      [selectionMode]="'single'"
      (onItemClick)="navigateToProperty($event)"
      displayExpr="caption"
      hasItemsExpr="children"
    ></abc-tree>
  </div>
</div>
